/**
 * @generated SignedSource<<a039c5da32c3487aca30dca7aecc743c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraIssue_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraIssue";
  readonly description: string;
  readonly iconUrl: string | null | undefined;
  readonly id: string;
  readonly issue: {
    readonly assigneeField?: {
      readonly user: {
        readonly name: string;
        readonly picture: AGG$URL;
      } | null | undefined;
    } | null | undefined;
    readonly fieldsById: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly name: string;
          readonly project?: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly issueTypeAvatarUrl: AGG$URL | null | undefined;
    readonly issueTypeField?: {
      readonly issueType: {
        readonly name: string;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly labelsField?: {
      readonly selectedLabelsConnection: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly priorityField?: {
      readonly priority: {
        readonly iconUrl: AGG$URL | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly webUrl: AGG$URL | null | undefined;
  } | null | undefined;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraIssue_AtlassianSearchPage";
};
export type searchJiraIssue_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraIssue_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraIssue_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ScalarField",
  "name": "description"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v6 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIssueTypeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    }
  ],
  "kind": "Fragment",
  "name": "searchJiraIssue_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "issueTypeAvatarUrl"
        },
        {
          "kind": "ScalarField",
          "name": "webUrl"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "condition": "includeIssueTypeField",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": (v8/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "ids",
              "value": [
                "project"
              ]
            }
          ],
          "concreteType": "JiraIssueFieldConnection",
          "kind": "LinkedField",
          "name": "fieldsById",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    (v7/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "JiraProject",
                          "kind": "LinkedField",
                          "name": "project",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v7/*: any*/)
                          ]
                        }
                      ],
                      "type": "JiraProjectField"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "fieldsById(ids:[\"project\"])"
        },
        {
          "condition": "includeAssigneeField",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraSingleSelectUserPickerField",
              "kind": "LinkedField",
              "name": "assigneeField",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "condition": "includeJiraLiteModeFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraPriorityField",
              "kind": "LinkedField",
              "name": "priorityField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraPriority",
                  "kind": "LinkedField",
                  "name": "priority",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    (v6/*: any*/)
                  ]
                }
              ]
            },
            {
              "concreteType": "JiraLabelsField",
              "kind": "LinkedField",
              "name": "labelsField",
              "plural": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 5
                    }
                  ],
                  "concreteType": "JiraLabelConnection",
                  "kind": "LinkedField",
                  "name": "selectedLabelsConnection",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraLabelEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraLabel",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v8/*: any*/)
                        }
                      ]
                    }
                  ],
                  "storageKey": "selectedLabelsConnection(first:5)"
                }
              ]
            }
          ]
        }
      ]
    },
    (v9/*: any*/),
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v4/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultJiraIssue"
};
})();

(node as any).hash = "cfed7996442e94ed7bbe261e5876cbda";

export default node;
